export default {
  staticBG: -10,
  scrollButton: 10,
  deepNotificationBar: 20,
  header: 30,
  shallowNotificationBar: 40,
  blogA11yButton: 50,
};
